import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';

const GridDateButton = ({
  setOpen,
  value: buttonValue,
  ...buttonParams
}) => (
  <Button
    {...buttonParams}
    variant="outlined"
    sx={{
      backgroundColor: 'white',
      width: '100%',
      borderRadius: 2,
      pl: 1,
      borderColor: 'gray.A400' }}
    onClick={() => setOpen((prev) => !prev)}
    startIcon={<EventOutlinedIcon sx={{ color: 'secondary.A400', width: { xs: 15, md: 25 }, height: { xs: 15, md: 25 } }} />}
  >
    <Typography color={buttonValue ? 'text.primary' : 'text.secondary'} variant="small_2" fontWeight={500}>
      {buttonValue ? buttonValue.format('DD-MM-YYYY') : 'Selecciona una fecha'}
    </Typography>
  </Button>
);

GridDateButton.propTypes = {
  setOpen: PropTypes.func.isRequired,
  value: PropTypes.shape({
    format: PropTypes.func,
  }),
};

GridDateButton.defaultProps = {
  value: null,
};

export default GridDateButton;
